export class baseServer {
  constructor(data) {
    for(let index in data){
      this[index]=data[index]
    }
  }
}


// WEBPACK FOOTER //
// ./src/server/base.js